import { render, staticRenderFns } from "./AppHelpCenter.vue?vue&type=template&id=3ddb5322&scoped=true"
import script from "./AppHelpCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHelpCenter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppHelpCenter.vue?vue&type=style&index=0&id=3ddb5322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb5322",
  null
  
)

export default component.exports